import classNames from 'classnames';
import React from 'react';
import './Divider.scss';
import IDividerProps from './DividerProps';

const Divider = ({ className }: IDividerProps) => <div className={classNames('divider', className)} />;

export default Divider;
